import { useState, useEffect, useCallback } from 'react';
import { APIGetUnreadNotificationsCount } from '../api/notifications/Notifications';

export const useNotification = (userId) => {
  const [unreadNotifications, setUnreadNotifications] = useState(0);

  const updateNotificationCount = useCallback(async () => {
    if (!userId) {
      return;
    }
    try {
      const count = await APIGetUnreadNotificationsCount(userId);
      setUnreadNotifications(count);
    } catch (error) {
      console.error('Error fetching unread notifications count:', error);
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      updateNotificationCount();
    }
  }, [userId, updateNotificationCount]);

  return { unreadNotifications, updateNotificationCount };
};
